import { DefaultState } from '@src/redux/types'

import { DASHBOARD_STUDENT, DASHBOARD_V2_STUDENT } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [DASHBOARD_STUDENT]: DefaultState<`${typeof API.DASHBOARD_STUDENT}`, 'get'>
  [DASHBOARD_V2_STUDENT]: DefaultState<`${typeof API.DASHBOARD_V2_STUDENT}`, 'get'>
} = () => ({
  [DASHBOARD_STUDENT]: defaultState(),
  [DASHBOARD_V2_STUDENT]: defaultState(),
})
